import { ButtonList } from '../button-list';

export class UserButton extends ButtonList {
  name = 'users';
}
